import React, { useMemo } from "react";
import { Input, Popover, Table } from "reactstrap";

import fa4icons from "./IconField/fa4icons";
import "./IconField.css";

// I may of gone too far with this (:

export const IconField = (props) => {
  const [search, setSearch] = React.useState("");
  const [isOpen, setIsOpen] = React.useState(false);
  const toggle = () => setIsOpen(!isOpen);

  const filteredIcons = useMemo(() => {
    if (search) {
      return _.filter(fa4icons, (icon) => _.includes(icon, search));
    }
    return fa4icons;
  }, [search]);


  const chunkedIcons = useMemo(() => _.chunk(filteredIcons, 15), [filteredIcons]);

  const {
    input: { value, onChange },
  } = props;

  return (
    <>
      <div className="m-1" style={{ width: "25px", height: "25px", border: "1px solid", cursor: "pointer" }} id="font_selector" onClick={toggle}>
        <div className="text-center">
          <i className={`fa ${value}`} />
        </div>
      </div>
      <Popover toggle={toggle} isOpen={isOpen} target="font_selector" trigger="legacy">
        <Input
          placeholder="Search..."
          className="w-100"
          onChange={(e) => {
            setSearch(e.target.value);
          }}
          value={search}
        />
        {isOpen && (
          <Table className="hover-cell">
            <tbody>
              {_.map(chunkedIcons, (chunk) => {
                return (
                  <tr>
                    {_.map(chunk, (icon) => (
                      <td
                        onClick={() => {
                          onChange(icon);
                          toggle();
                        }}
                        style={{ backgroundColor: icon == value ? "#f5f5f5" : null }}
                      >
                        <i className={`fa ${icon}`} />
                      </td>
                    ))}
                  </tr>
                );
              })}
            </tbody>
          </Table>
        )}
      </Popover>
    </>
  );
};

export default IconField;
